/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParkingPriceApiFrom } from '../../models/parking-price-api-from';

export interface ApiV3ServiceGetParkingPriceGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * id ts
 */
  vehId?: number;

/**
 * near the parking lot
 */
  parkCode?: string;

/**
 * estimated parking time in minutes
 */
  duration?: number;
}

export function apiV3ServiceGetParkingPriceGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceGetParkingPriceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPriceApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceGetParkingPriceGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('vehId', params.vehId, {});
    rb.query('parkCode', params.parkCode, {});
    rb.query('duration', params.duration, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParkingPriceApiFrom>;
    })
  );
}

apiV3ServiceGetParkingPriceGet$Plain.PATH = '/api/v3/service/GetParkingPrice';
